import "./Curation.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurTrainingPathways from "./sections/OurTrainingPathways";
import DesignYourIdealJourney from "./sections/DesignYourIdealJourney";
import InquiryPortal from "./sections/InquiryPortal";
import MidnightRunnersCollection from "@/reusable_sections/Footer";
export default function CurationPage() {
  return <div>
      <MainNavigation />
      <OurTrainingPathways />
      <DesignYourIdealJourney />
      <InquiryPortal />
      <MidnightRunnersCollection />
    </div>;
}